// Pathify config
import pathify from '@/store/pathify';

import Vue from 'vue';
import Vuex from 'vuex';

import createPersistedState from 'vuex-persistedstate';
import {getModule} from 'vuex-module-decorators';
import {ProjectStore} from '@/store/projectStore';
import UserStore from '@/store/userStore';
import DesignStore from '@/modules/design/designStore';
import LccaStore from '@/modules/lcca/lccaStore';
import AgencyCostStore from '@/modules/agencyCost/store';
import PerRoadStore from '@/modules/perRoad/store';
import StructureStore from "@/modules/structure/store";


Vue.use(Vuex);

const env = process.env.VUE_APP_DEPLOYMENT_ENV;


const state = {
  debug: true,
  // token: '',
  // user: null,
};

export const store = new Vuex.Store({
  // @ts-ignore
  plugins: [
    pathify.plugin,
    createPersistedState(),
  ],
  state,
  getters: {},
  mutations: {},
  actions: {},
  modules: {
    project: ProjectStore,
    user: UserStore,
    design: DesignStore,
    lcca: LccaStore,
    agency: AgencyCostStore,
    perroad: PerRoadStore,
    structure: StructureStore
  },
});


// NOTE
// I think I exported these from this file so there would be only one variable referenced for each substore
// and we wouldn't have to re-call getModule each time. What breaks if we do it the other way? It's really annoying
// for the IDE to bring us to this spot when using go-to-declaration

export const projectStore = getModule(ProjectStore, store);
export const userStore = getModule(UserStore, store);
export const designStore = getModule(DesignStore, store);
export const lccaStore = getModule(LccaStore, store);
export const agencyStore = getModule(AgencyCostStore, store);
export const perRoadStore = getModule(PerRoadStore, store);
export const structureStore = getModule(StructureStore, store);

export const allStores = [
  projectStore,
  userStore,
  designStore,
  lccaStore,
  agencyStore,
  perRoadStore,
  structureStore,
];
